import React, { useState } from 'react';
import { Input, Label } from "reactstrap";

function ProjectDetails({ label, placeholder, onChange, rows, cols, value, disabled }) {
    const [projectDetails, setProjectDetails] = useState([value]);

    const handleChange = (event) => {
        const valueE = event.target.value;
        setProjectDetails(event.target.value);
        if (typeof onChange == 'function') {
            onChange(valueE);
        }
    }

    let className = !label
        ? "d-none"
        : "";
    let placeHolder = placeholder !== undefined
        ? placeholder
        : "Enter a description of your project requirements";

    return (
        <div className="form-group">
            <Label className={ className }>
                { label }
            </Label>
            <Input
                type="textarea"
                value={projectDetails}
                rows={rows}
                cols={cols}
                placeholder={placeHolder}
                onChange={handleChange}
                disabled={disabled}
            />
        </div>
    );
}

export default ProjectDetails;